export default __webpack_public_path__ + "eeabdec5eeaa6d5ac3f9373dc62ffbc4.woff2";